import React from 'react';
import { Box, Typography, Container } from '@mui/material';
import Grid from '@mui/material/Grid';
import { motion } from 'framer-motion';
import customizationSteps from '../../assets/customization/customization-steps.png';

interface Step {
  number: string;
  title: string;
}

const steps: Step[] = [
  {
    number: '01',
    title: 'Choose the software solution',
  },
  {
    number: '02',
    title: 'Provide us with color palette, logo, brand book.',
  },
  {
    number: '03',
    title: 'Select integrations from the list or request additionals',
  },
  {
    number: '04',
    title: 'Setup within 2 weeks and you can start the business',
  },
];

const CustomizationSection: React.FC = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <Box
      component="section"
      sx={{
        width: '100%',
        padding: '120px 0px 120px 0px',
        overflow: 'hidden',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Container maxWidth="xl" sx={{ maxWidth: '1280px', width: '90%' }}>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={containerVariants}
        >
          <Grid container spacing={4} sx={{ alignItems: 'center' }}>
            {/* LEFT: Images */}
            <Grid size={{ xs: 12, md: 6 }}>
              <motion.div variants={itemVariants}>
                <Box
                  component="img"
                  src={customizationSteps}
                  alt="Customization Steps"
                  sx={{
                    width: '100%',
                    height: 'auto',
                  }}
                />
              </motion.div>
            </Grid>

            {/* RIGHT: Heading, Text and Steps */}
            <Grid size={{ xs: 12, md: 6 }} sx={{ pl: { md: '120px' } }}>
              <motion.div variants={itemVariants}>
                <Box sx={{ textAlign: { xs: 'center', md: 'left' }, mb: '40px' }}>
                  <Typography
                    variant="h2"
                    sx={{
                      fontSize: { xs: '36px', md: '48px' },
                      fontWeight: 600,
                      color: '#070707',
                      mb: 2,
                      lineHeight: 1.2,
                    }}
                  >
                    Customise ready-made Software
                  </Typography>
                  <Typography sx={{ fontSize: { xs: '16px', md: '20px' }, color: '#070707', lineHeight: 1.6 }}>
                    All software solutions are possible to customise not only with the company colour palette, but also to implement changes according to your UI/UX requests.
                  </Typography>
                </Box>

                {steps.map((step, index) => (
                  <Box
                    key={index}
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      mb: index < steps.length - 1 ? '16px' : 0,
                      gap: '16px',
                    }}
                  >
                    <Box
                      sx={{
                        backgroundColor: '#5378C3',
                        borderRadius: '500px',
                        padding: '5px 0px',
                        minWidth: '35px',
                        width: '35px',
                        textAlign: 'center',
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: '16px',
                          fontWeight: 600,
                          color: '#FFFFFF',
                          lineHeight: 1,
                        }}
                      >
                        {step.number}
                      </Typography>
                    </Box>
                    <Typography
                      sx={{
                        fontSize: '16px',
                        color: '#070707',
                        lineHeight: 1.4,
                        fontWeight: 600,
                      }}
                    >
                      {step.title}
                    </Typography>
                  </Box>
                ))}
              </motion.div>
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default CustomizationSection;
